<template>
  <div class="button">
    <span role="button" class="btn">
      <FontawesomeIcon :icon="['fal','pencil-alt']" class="icn" />
      編集
    </span>
  </div>
</template>

<script>
import { defineComponent, reactive, ref, computed, onMounted } from '@vue/composition-api'

export default defineComponent({
  props: {
    isChecked: {
      type: Boolean,
      default: false
    }
  },
  setup (props, context) {

    const group1 = reactive({
      isChecked: computed(() => { return props.isChecked })
    })

    return {
      group1
    }
  }
})
</script>

<style lang="scss" scoped>
.button {
  // width: 134px;
  .icn {
    margin-right: 8px;
  }
}
</style>
